import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class CountryModel extends Model {
  static reducer(action, CountryModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Country.schema:
        action.payload.forEach((payload) => {
          const dbData = CountryModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          CountryModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
CountryModel.modelName = "CountryModel";

CountryModel.fields = {
  id: attr(),
};

export default CountryModel;